<script setup lang="ts">
import { ModalConfirmation } from '@shared/ui/modals'

defineOptions({
  name: 'ModalConfirmExitChange',
})

defineProps<{
  show: boolean
  title: string
}>()
</script>

<template>
  <ModalConfirmation
    :show="show"
    :title="title"
    button-title="Yes"
    cancel-title="No"
    overlay-class-name="modal-confirm-exit-change"
    is-close-icon
  />
</template>

<style scoped lang="scss" src="./ModalConfirmExitChange.scss" />
